module.exports = __webpack_public_path__ + "img/bg-roy-marmelstein.fbc59001.jpg";